import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEmployeeChangesData(employeeId?: number) {
    const { data: employeeChangesData, isPending: isLoadingEmployeeChangesData } = useQuery({
        queryKey: [QueryKey.EMPLOYEE_CHANGES_DATA, employeeId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.salary.employee.changes.show', employeeId));
            return data;
        },
        placeholderData: [],
        enabled: !!employeeId,
    });

    return {
        employeeChangesData,
        isLoadingEmployeeChangesData,
    };
}
